export default __webpack_public_path__ + "static/media/testkit.ea37303a.svg";